
import {registerComponent} from '@helpers/vue'

import router from './router'

import AdministrationModuleRoot from './AdministrationModuleRoot'

registerComponent(AdministrationModuleRoot, 'administration', {router})
